import { render, staticRenderFns } from "./FeatureFlags.vue?vue&type=template&id=50b61b58&scoped=true&"
import script from "./FeatureFlags.vue?vue&type=script&lang=js&"
export * from "./FeatureFlags.vue?vue&type=script&lang=js&"
import style0 from "./FeatureFlags.vue?vue&type=style&index=0&id=50b61b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b61b58",
  null
  
)

component.options.__file = "FeatureFlags.vue"
export default component.exports